import * as Yup from "yup"

export const createResourceSchema = Yup.object().shape({
  title: Yup.object({
    uz: Yup.string().required("Majburiy"),
    ru: Yup.string().required("Majburiy"),
    en: Yup.string().required("Majburiy"),
  }),
  description: Yup.object({
    uz: Yup.string().required("Majburiy"),
    ru: Yup.string().required("Majburiy"),
    en: Yup.string().required("Majburiy"),
  }),
  banner: Yup.mixed().required("Majburiy"),
  file: Yup.mixed().required("Majburiy"),
})